import {
  GET_ICMS_SUCCESS,
  GET_ICMS_FAILURE,
  CLASSIFY_PRODUCT_ICMS_SUCCESS,
  CLASSIFY_SUGGESTION_ICMS_SUCCESS,
  CLASSIFY_SUGGESTION_ICMS_FAILURE,
  PUT_CLASSIFY_ICMS_SUCCESS,
  DELETE_CLASSIFY_ICMS_SUCCESS,
  GET_PERIOD_CLASSIFY_ICMS_SUCCESS,
  ICMS_CLEAN,
  ICMS_CLEAR_COMPANY
} from "../../../../constants/actionTypes";
const INITIAL_STATE = {
  list: [],
  data: {},
  status: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_ICMS_SUCCESS:
      return {
        ...state,
        list: action.payload.Items,
        paging: action.payload.Paging,
        total: action.payload.CustomData,
        period: action.payload.Periodo,
        statusError: action.payload.StatusErro,
      };
    case GET_ICMS_FAILURE:
      return {
        ...state,
        status: 400,
      };
    case CLASSIFY_PRODUCT_ICMS_SUCCESS:
      return {
        ...state,
        status: action.payload?.StatusCode,
      };
    case CLASSIFY_SUGGESTION_ICMS_SUCCESS:
      return {
        ...state,
        status: action.payload?.StatusCode,
      };
    case CLASSIFY_SUGGESTION_ICMS_FAILURE:
      return {
        ...state,
        status: action.payload?.StatusCode,
      };
    case PUT_CLASSIFY_ICMS_SUCCESS:
      return {
        ...state,
        data: action.payload,
      };
    case DELETE_CLASSIFY_ICMS_SUCCESS:
      return {
        ...state,
        data: action.payload,
      };
    case GET_PERIOD_CLASSIFY_ICMS_SUCCESS:
      return {
        ...state,
        query: action.payload.Retorno,
        statusQuery: action.payload?.StatusCode,
      };
    case ICMS_CLEAN:
      return {
        ...state,
        data: {},
        status: null,
      };
    case ICMS_CLEAR_COMPANY:
      return {
        ...state,
        data: {},
        list: [],
        status: null,
      };
    default:
      return state;
  }
};
